import { render, staticRenderFns } from "./fileCard.vue?vue&type=template&id=34655fa2&"
import script from "./fileCard.vue?vue&type=script&lang=js&"
export * from "./fileCard.vue?vue&type=script&lang=js&"
import style0 from "./fileCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports